import { render, staticRenderFns } from "./UiTooltip.vue?vue&type=template&id=252152b6&"
import script from "./UiTooltip.vue?vue&type=script&lang=js&"
export * from "./UiTooltip.vue?vue&type=script&lang=js&"
import style0 from "./UiTooltip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports